import { createFileRoute } from "@tanstack/react-router";

import { ForgeAutomationEditPage } from "../components/automations/ForgeAutomationEditPage";

export const Route = createFileRoute("/_chat/automations/$automationId_/edit")({
  component: AutomationEditRoute,
});

function AutomationEditRoute() {
  const { automationId } = Route.useParams();
  return <ForgeAutomationEditPage automationId={automationId} />;
}
